const AnnouncementRoutes = [
    {
        path: '/announcement/announce-event',
        name: 'Announcement',
        component: () => import('../views/Announcement/AnnouncementView.vue'),
    },
]
export default AnnouncementRoutes
